<template>
  <div :style="{ margin: '-8px' }">
    <v-layout align-center>
      <v-flex class="pa-2 headline primary--text">{{ $t('survey') }}</v-flex>
      <v-flex v-if="!isEdit && !isNotAccess" class="pa-2" shrink>
        <v-btn
          :disabled="isLoading"
          class="ma-0"
          color="primary"
          icon
          outline
          @click="isEdit = true"
        >
          <v-icon small>edit</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <div class="pa-2">
      <v-layout fill-height wrap>
        <v-flex v-if="isZwizAdmin()" class="mb-4" xs12>
          <v-switch
            v-model="closed_with_survey"
            :readonly="!isEdit"
            class="ma-0 pa-0"
            color="primary"
            hide-details
            label="Closed with Survey"
          />
        </v-flex>
        <template
          v-if="
            closed_with_survey_message &&
            closed_with_survey_message.length < 5 &&
            isEdit &&
            closed_with_survey
          "
        >
          <v-flex class="mb-4" xs12>
            <button :disabled="isLoading" class="survey-button__wrapper" @click="showDialog = true">
              <i class="fa fa-plus"></i>
              <span>{{ $t('survey') }}</span>
            </button>
          </v-flex>
        </template>
      </v-layout>
      <SurveyFormDialog
        v-if="closed_with_survey"
        ref="surveyForm"
        v-model="showDialog"
        @submit="handleSubmitSurvey"
      />
      <v-layout v-if="closed_with_survey" fill-height wrap>
        <v-flex
          v-for="(survey, index) in closed_with_survey_message"
          :key="`survey_${index}`"
          class="mb-3"
          xs12
        >
          <SurveyCard
            :button-name="survey.button_name"
            :created-at="survey.created_at"
            :expired-at="survey.expire_survey_timestamp"
            :is-default="survey.is_default"
            :is-edit="isEdit"
            :message="survey.message"
            :survey-id="survey.survey_id"
            :survey-name="survey.survey_name"
            :updated-at="survey.updated_at"
            @delete="handleDeleteSurvey(index)"
            @edit="handleEdit(index)"
          />
        </v-flex>
      </v-layout>
    </div>
    <div v-if="isEdit" class="mt-3">
      <v-layout justify-center wrap>
        <v-flex shrink>
          <v-btn :disabled="isLoading" color="grey" outline @click="isEdit = false"
            >{{ $t('cancel') }}
          </v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn :disabled="isLoading" color="primary" depressed @click="handleSubmit"
            >{{ $t('Save') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SurveyFormDialog from './SurveyFormDialog.vue'
import SurveyCard from './SurveyCard.vue'
import ticket3PageApi from '@/api/ticket3/page'
import { handleApiError } from '@/api/util'
import { PAGE_GROUP } from '@/constants/page.js'

export default {
  name: 'CustomerSupportServiceSurveySetting',
  components: { SurveyFormDialog, SurveyCard },
  data() {
    return {
      isEdit: false,
      isLoading: false,
      showDialog: false,
      closed_with_survey: false,
      closed_with_survey_message: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    isNotAccess() {
      return this.selectedBot.page_group === PAGE_GROUP.CIMB_WEALTH && !this.isZwizAdmin()
    }
  },
  watch: {
    selectedBot(value) {
      const { closed_with_survey, closed_with_survey_message = [] } = value.ticket_v3_config
      this.closed_with_survey = closed_with_survey
      this.closed_with_survey_message = closed_with_survey_message
    }
  },
  mounted() {
    const { closed_with_survey, closed_with_survey_message = [] } =
      this.selectedBot.ticket_v3_config
    this.closed_with_survey = closed_with_survey
    this.closed_with_survey_message = closed_with_survey_message
  },
  methods: {
    handleSubmitSurvey(data, index) {
      if (data.is_default) {
        this.closed_with_survey_message = this.closed_with_survey_message.map((survey) => {
          return {
            ...survey,
            is_default: false
          }
        })
      }
      if (index !== null && index >= 0) {
        this.$set(this.closed_with_survey_message, index, data)
        return
      }
      this.closed_with_survey_message.push(data)
    },
    handleEdit(index) {
      const selectSurvey = this.closed_with_survey_message[index]
      if (selectSurvey) {
        this.$refs.surveyForm.handleInitData(selectSurvey, index)
      }
    },
    async handleDeleteSurvey(index) {
      const result = await this.$swal({
        title: this.$t('Do you want to delete {name}?', {
          name: this.$t('survey')
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        if (index > -1 && this.closed_with_survey_message.length > 0) {
          this.closed_with_survey_message.splice(index, 1)
        }
      }
    },
    async handleSubmit() {
      try {
        this.isLoading = true
        const response = await ticket3PageApi.putTicketConfig({
          data: {
            page_id: this.selectedBot.pageid,
            ticket_config: {
              ...this.selectedBot.ticket_v3_config,
              closed_with_survey: this.closed_with_survey,
              closed_with_survey_message: this.closed_with_survey_message
            }
          }
        })
        if (response.status === 204) {
          await this.$swal.fire({
            title: this.$t('Successfully'),
            type: 'success'
          })
          this.$store.dispatch('updateBotDetail')
        }
      } catch (error) {
        console.error(error)
        await handleApiError(error)
      } finally {
        this.isLoading = false
        this.isEdit = false
      }
    }
  }
}
</script>
<style lang="css" scoped>
.survey-button__wrapper {
  min-height: 64px;
  border-radius: 16px;
  border: 1px dashed #ff846d;
  background: #fff0ee;
  position: relative;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  width: 100%;
  color: #ff846d;
}

.survey-button__wrapper:hover {
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/CustomerSupportService/SurveySetting.vue